<!-- <p>what-customers works!</p> -->
<div id="carousel" class="carousel slide" data-ride="carousel">
    <ol class="carousel-indicators">
        <li data-target="#carousel" data-slide-to="0" class="active"></li>
        <li data-target="#carousel" data-slide-to="1"></li>
    </ol>
    <div class="carousel-inner" role="listbox">
        <div class="carousel-item active">
            <div class="row">
                <div class="col-md-6">
                    <div class="swiper-avatar text"><img src="assets/images/new/shivkumar.webp" alt="shivkumar">
                    </div>
                    <p class="cite testiname textred mt-30" style="text-align: center;">- Shivkumar
                        Pandey</p>
                    <span class="cite textblue designation1">Group CISO<br></span>
                    <span class="cite textblue designation2">Bombay Stock
                        Exchange</span>
                </div>
                <div class="col-md-6  d-flex align-items-center">

                    <p class="pt-3">"<span class="textred">App</span><span
                            class="textblue">Protectt</span>
                        Mobile App RASP
                        security helped
                        us to enhance our Mobile App Security with quick
                        implementation and also provided visibility into threats
                        and prevention on real-time. Now, our team can focus
                        more on App Features development while <span class="textred">App</span><span
                            class="textblue">Protectt</span> is
                        adding a layer of security for our mobile apps. "</p>


                </div>
            </div>
        </div>
        <div class="carousel-item">
            <div class="row">
                <div class="col-md-6">
                    <div class="swiper-avatar text"><img src="assets/images/new/nilesh_sangoi.webp" alt="nilesh sangoi">
                    </div>
                    <p class="cite testiname textred  mt-30" style="text-align: center;">- Nilesh Sangoi</p>
                    <span class="cite textblue designation1">Chief Information
                        Officer</span>
                    <span class="cite textblue designation2"><br>Fincare Small
                        Finance
                        Bank</span>
                </div>
                <div class="col-md-6  d-flex align-items-center">
                    <p class="pt-3">"<span class="textred">App</span><span
                        class="textblue">Protectt</span> Mobile App RASP
                    security helped
                    us to enhance our Mobile App Security with quick
                    implementation and also provided visibility into threats
                    and prevention on real-time. Now, our team can focus
                    more on App Features development while <span
                        class="textred">App</span><span
                        class="textblue">Protectt</span> is
                    adding a layer of security for our mobile apps. "</p>

                </div>
            </div>
        </div>
    </div>

    <a class="carousel-control-prev" href="#carousel" role="button" data-slide="prev">
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="sr-only">Previous</span>
    </a>
    <a class="carousel-control-next" href="#carousel" role="button" data-slide="next">
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="sr-only">Next</span>
    </a>

</div>